<template>
  <v-dialog
    v-model="showDialog"
    fullscreen
    hide-overlay
  >
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-img
          :src="previewImage"
          :height="height"
          :aspect-ratio="aspectRatio"
        />
        <v-icon class="fullscreen-icon" v-on="on">fullscreen</v-icon>
      </div>
    </template>
    <v-card>
      <v-toolbar dark color="dark">
        <v-btn icon dark @click="showDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title v-text="title"/>
      </v-toolbar>
      <v-img
        :src="fullscreenImage"
        :contain="true"
      />
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ImageWithFullscreenDialog',

  props: {
    fullscreenImage: String,
    previewImage: String,
    title: String,
    height: {
      type: String,
      default: null,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      showDialog: false,
    }
  },
}
</script>

<style lang="sass" scoped>
.v-image
  cursor: pointer

.v-icon.fullscreen-icon
  color: white !important
  cursor: pointer
  font-size: 290%
  margin-top: -3rem
  position: absolute
  right: 0
  text-shadow: 1px 1px 3px black
</style>
